module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Aluno (turma)")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Assunto")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Participantes")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-right"
  }, [_vm._v("Data de envio")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sentMessages), function(message) {
    return _c('router-link', {
      key: message.messageGroup,
      class: {
        'active': message.notRead === 0, 'bold': message.notRead === 1
      },
      attrs: {
        "tag": "tr",
        "to": {
          path: ("/inbox/reply-message/" + (message.messageGroup))
        }
      }
    }, [_c('td', {
      staticClass: "view-message align-middle hidden-xs"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(message.student.name)), _c('br'), _vm._v(" "), (message.student.schoolClass && message.student.schoolClass.description) ? _c('small', [_vm._v("\n\t\t\t\t\t\t\t\tTurma: " + _vm._s(message.student.schoolClass.description) + "\n\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "view-message align-middle"
    }, [_vm._v(_vm._s(message.subject))]), _vm._v(" "), _c('td', {
      staticClass: "view-message align-middle"
    }, [_vm._v(_vm._s(message.members))]), _vm._v(" "), _c('td', {
      staticClass: "view-message align-middle text-right"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(message.dateTime, 'DD/MM/YYYY HH:mm')) + "\n\t\t\t\t\t\t")])])
  })), _vm._v(" "), (_vm.sentMessages.length === 0) ? _c('tfoot', [_c('tr', [_c('td', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNenhuma mensagem enviada\n\t\t\t\t\t\t")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right"
  }, [(_vm.sentMessages.length > 0) ? _c('pagination', {
    attrs: {
      "layout": "prev, next"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49dfcc3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/inbox/message-send/list/list.vue
// module id = 1066
// module chunks = 1